// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Dapps.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  CreateDappRequest,
  CreateDappResponse,
  DeleteDappRequest,
  DeleteDappResponse,
  GetDappRequest,
  GetDappResponse,
  GetDappSecretKeyRequest,
  GetDappSecretKeyResponse,
  ResetDappRequest,
  ResetDappResponse,
  UpdateDappRequest,
  UpdateDappResponse,
} from "./Models/DappModels";

export const protobufPackage = "daisi.protos.v1";

export type DappsProtoDefinition = typeof DappsProtoDefinition;
export const DappsProtoDefinition = {
  name: "DappsProto",
  fullName: "daisi.protos.v1.DappsProto",
  methods: {
    get: {
      name: "Get",
      requestType: GetDappRequest,
      requestStream: false,
      responseType: GetDappResponse,
      responseStream: false,
      options: {},
    },
    create: {
      name: "Create",
      requestType: CreateDappRequest,
      requestStream: false,
      responseType: CreateDappResponse,
      responseStream: false,
      options: {},
    },
    reset: {
      name: "Reset",
      requestType: ResetDappRequest,
      requestStream: false,
      responseType: ResetDappResponse,
      responseStream: false,
      options: {},
    },
    getSecretKey: {
      name: "GetSecretKey",
      requestType: GetDappSecretKeyRequest,
      requestStream: false,
      responseType: GetDappSecretKeyResponse,
      responseStream: false,
      options: {},
    },
    update: {
      name: "Update",
      requestType: UpdateDappRequest,
      requestStream: false,
      responseType: UpdateDappResponse,
      responseStream: false,
      options: {},
    },
    delete: {
      name: "Delete",
      requestType: DeleteDappRequest,
      requestStream: false,
      responseType: DeleteDappResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface DappsProtoServiceImplementation<CallContextExt = {}> {
  get(request: GetDappRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetDappResponse>>;
  create(request: CreateDappRequest, context: CallContext & CallContextExt): Promise<DeepPartial<CreateDappResponse>>;
  reset(request: ResetDappRequest, context: CallContext & CallContextExt): Promise<DeepPartial<ResetDappResponse>>;
  getSecretKey(
    request: GetDappSecretKeyRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetDappSecretKeyResponse>>;
  update(request: UpdateDappRequest, context: CallContext & CallContextExt): Promise<DeepPartial<UpdateDappResponse>>;
  delete(request: DeleteDappRequest, context: CallContext & CallContextExt): Promise<DeepPartial<DeleteDappResponse>>;
}

export interface DappsProtoClient<CallOptionsExt = {}> {
  get(request: DeepPartial<GetDappRequest>, options?: CallOptions & CallOptionsExt): Promise<GetDappResponse>;
  create(request: DeepPartial<CreateDappRequest>, options?: CallOptions & CallOptionsExt): Promise<CreateDappResponse>;
  reset(request: DeepPartial<ResetDappRequest>, options?: CallOptions & CallOptionsExt): Promise<ResetDappResponse>;
  getSecretKey(
    request: DeepPartial<GetDappSecretKeyRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetDappSecretKeyResponse>;
  update(request: DeepPartial<UpdateDappRequest>, options?: CallOptions & CallOptionsExt): Promise<UpdateDappResponse>;
  delete(request: DeepPartial<DeleteDappRequest>, options?: CallOptions & CallOptionsExt): Promise<DeleteDappResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
